import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { FiArrowLeft } from 'react-icons/fi';

import api from '../../services/api';
import './styles.css';

import logoImg from '../../assets/logo.svg';

export default function NewIncident(){
  const ongId = localStorage.getItem('ongId');

  const [ title, setTitle ] = useState('');
  const [ description, setDescription ] = useState('');
  const [ value, setValue ] = useState('');

  const history = useHistory();

  async function handleNewIncident(e){
    e.preventDefault();

    const data = {
      title, description, value
    };

    await api.post('incidents', data, {
      headers: {
        authorization: ongId
      }
    })
    .then(response => {
      history.push('/profile')
    })
    .catch(err => {
      alert('Erro ao cadastrar, tente novamente');
    });
  }

  return(
    <div className="new-incident-container">
      <div className="content">
        <section>
          <img src={logoImg} alt="Be The Hero"/>
          <h1>Cadastrar novo caso</h1>
          <p>
            Descreva o caso detalhadamente para encontrar um herói para resolver isso.
          </p>

          <Link className="back-link" to="/profile">
            <FiArrowLeft size={16} color="var(--accent-color)"/>
            Voltar para home
          </Link>
        </section>

        <form onSubmit={handleNewIncident}>
          <input 
            placeholder="Título do caso" required="required" pattern="[A-z-À-ž-0-9\s]{1,50}"
            value={title}
            onChange={ e => setTitle(e.target.value) }
          />
          <textarea 
            placeholder="Descrição" required="required" pattern="[A-z-À-ž-0-9\s]{1,1024}"
            value={description}
            onChange={ e => setDescription(e.target.value) }
          />
          <input 
            placeholder="Valor em reais" required="required" type="number" min="1" step="any" pattern="^\d+(\.|\,)\d{2}$"
            value={value}
            onChange={ e => setValue(e.target.value) }
          />

          <button className="button" type="submit">Cadastrar</button>
        </form>
      </div>
    </div>
  );
};